module.exports = __webpack_public_path__ + "media/images/lb/243-086f2bcc422ac1326608a9d8a2065e54.svg";